import styled from 'react-emotion';

export const Spacer = styled.div`
	padding-bottom: ${({ size }) => (size ? size + 'rem' : '1rem')};
`;
